import React from 'react'

import ShareYourIdea from '../../../react4xp/components/ShareYourIdea'

function ShareYourIdeaPart({title, intro, cta, colors}) {
    return (
		<ShareYourIdea 
			title={title}
			content={intro}
			cta={cta}
			section={{bgColor: colors.bgColor}}
		/>
    )
}

export default (props) => <ShareYourIdeaPart {...props} />
